// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Pasarela.css */

.pasarela-page {
    background: var(--sn-superficie-2);
    padding: 2rem;
    border-radius: 8px;
    box-shadow: var(--sn-sombra);
    max-width: 600px;
    margin: 2rem auto;
  }
  
  .pasarela-page h4 {
    font-size: 1.75rem;
    color: var(--sn-texto);
    margin-bottom: 1rem;
    font-weight: 600;
  }
  
  .pasarela-page p {
    font-size: 1rem;
    color: var(--sn-texto-2);
    margin: 0.4rem 0;
  }
  
  .pasarela-page a {
    color: var(--sn-marca);
    text-decoration: none;
  }
  .pasarela-page a:hover {
    text-decoration: underline;
  }
  
  .pasarela-info {
    background: var(--sn-superficie);
    padding: 1rem;
    border-radius: 6px;
    margin-bottom: 1.5rem;
  }
  
  .pasarela-info p + p {
    margin-top: 0.5rem;
  }
  
  .btn-link {
    color: var(--sn-marca);
    font-size: 0.9rem;
  }
  .btn-link:hover {
    color: var(--sn-marca-fuerte);
    text-decoration: none;
  }
  
  .payphone-btn {
    display: inline-flex;
    align-items: center;
    padding: 0.6rem 1rem;
    font-size: 1rem;
    border-radius: 50px;
    transition: background 0.2s, transform 0.1s;
  }
  
  .payphone-btn:hover {
    background: var(--sn-accion-hover);
    transform: translateY(-2px);
  }
  
  .payphone-btn img.img-btn {
    width: 24px;
    height: auto;
    margin-right: 0.5rem;
  }
  
  @media (max-width: 576px) {
    .pasarela-page {
      padding: 1rem;
      margin: 1rem;
    }
    .pasarela-page h4 {
      font-size: 1.5rem;
    }
    .payphone-btn {
      width: 100%;
      justify-content: center;
    }
  }
  /* Botón circular de volver */
.btn-back {
    background: transparent;
    border: none;
    cursor: pointer;
    text-align: center;
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 1.5rem;
    padding: 0;
  }
  
  .btn-back .icon-circle {
    width: 56px;
    height: 56px;
    background-color: var(--sn-info); /* grafito neutro: es un boton secundario */
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.25rem;
    color: var(--sn-texto-invertido);
    transition: background-color 0.2s, transform 0.1s;
  }
  
  .btn-back .icon-circle:hover {
    background-color: var(--sn-info-texto);
    transform: translateY(-2px);
  }
  
  .btn-back .back-text {
    margin-top: 6px;
    font-size: 0.85rem;
    color: var(--sn-texto-2);
    font-weight: 500;
  }
  .payphone-card {
    background: var(--sn-superficie);
    border: 1px solid var(--sn-borde);
    border-radius: 8px;
    padding: 1rem 1.25rem;
    max-width: 380px;          /* opcional */
    font-size: 0.92rem;
  }
  
  .payphone-title {
    font-weight: 600;
    font-size: 1rem;
    letter-spacing: .4px;
    color: var(--sn-marca);    /* acento de marca */
  }

  .payphone-card strong {
    color: var(--sn-marca);
  }
  .loading-overlay {
    position: fixed;
    inset: 0;
    background: var(--sn-fondo);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1050;
    flex-direction: column;
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/Pasarela.css"],"names":[],"mappings":"AAAA,iBAAiB;;AAEjB;IACI,kCAAkC;IAClC,aAAa;IACb,kBAAkB;IAClB,4BAA4B;IAC5B,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,wBAAwB;IACxB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,qBAAqB;EACvB;EACA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gCAAgC;IAChC,aAAa;IACb,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,6BAA6B;IAC7B,qBAAqB;EACvB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;IACf,mBAAmB;IACnB,2CAA2C;EAC7C;;EAEA;IACE,kCAAkC;IAClC,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,oBAAoB;EACtB;;EAEA;IACE;MACE,aAAa;MACb,YAAY;IACd;IACA;MACE,iBAAiB;IACnB;IACA;MACE,WAAW;MACX,uBAAuB;IACzB;EACF;EACA,6BAA6B;AAC/B;IACI,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,sBAAsB;IACtB,mBAAmB;IACnB,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gCAAgC,EAAE,2CAA2C;IAC7E,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gCAAgC;IAChC,iDAAiD;EACnD;;EAEA;IACE,sCAAsC;IACtC,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,wBAAwB;IACxB,gBAAgB;EAClB;EACA;IACE,gCAAgC;IAChC,iCAAiC;IACjC,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB,WAAW,aAAa;IACxC,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,sBAAsB,KAAK,oBAAoB;EACjD;;EAEA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,QAAQ;IACR,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,sBAAsB;EACxB","sourcesContent":["/* Pasarela.css */\n\n.pasarela-page {\n    background: var(--sn-superficie-2);\n    padding: 2rem;\n    border-radius: 8px;\n    box-shadow: var(--sn-sombra);\n    max-width: 600px;\n    margin: 2rem auto;\n  }\n  \n  .pasarela-page h4 {\n    font-size: 1.75rem;\n    color: var(--sn-texto);\n    margin-bottom: 1rem;\n    font-weight: 600;\n  }\n  \n  .pasarela-page p {\n    font-size: 1rem;\n    color: var(--sn-texto-2);\n    margin: 0.4rem 0;\n  }\n  \n  .pasarela-page a {\n    color: var(--sn-marca);\n    text-decoration: none;\n  }\n  .pasarela-page a:hover {\n    text-decoration: underline;\n  }\n  \n  .pasarela-info {\n    background: var(--sn-superficie);\n    padding: 1rem;\n    border-radius: 6px;\n    margin-bottom: 1.5rem;\n  }\n  \n  .pasarela-info p + p {\n    margin-top: 0.5rem;\n  }\n  \n  .btn-link {\n    color: var(--sn-marca);\n    font-size: 0.9rem;\n  }\n  .btn-link:hover {\n    color: var(--sn-marca-fuerte);\n    text-decoration: none;\n  }\n  \n  .payphone-btn {\n    display: inline-flex;\n    align-items: center;\n    padding: 0.6rem 1rem;\n    font-size: 1rem;\n    border-radius: 50px;\n    transition: background 0.2s, transform 0.1s;\n  }\n  \n  .payphone-btn:hover {\n    background: var(--sn-accion-hover);\n    transform: translateY(-2px);\n  }\n  \n  .payphone-btn img.img-btn {\n    width: 24px;\n    height: auto;\n    margin-right: 0.5rem;\n  }\n  \n  @media (max-width: 576px) {\n    .pasarela-page {\n      padding: 1rem;\n      margin: 1rem;\n    }\n    .pasarela-page h4 {\n      font-size: 1.5rem;\n    }\n    .payphone-btn {\n      width: 100%;\n      justify-content: center;\n    }\n  }\n  /* Botón circular de volver */\n.btn-back {\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    text-align: center;\n    display: inline-flex;\n    flex-direction: column;\n    align-items: center;\n    margin-bottom: 1.5rem;\n    padding: 0;\n  }\n  \n  .btn-back .icon-circle {\n    width: 56px;\n    height: 56px;\n    background-color: var(--sn-info); /* grafito neutro: es un boton secundario */\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 1.25rem;\n    color: var(--sn-texto-invertido);\n    transition: background-color 0.2s, transform 0.1s;\n  }\n  \n  .btn-back .icon-circle:hover {\n    background-color: var(--sn-info-texto);\n    transform: translateY(-2px);\n  }\n  \n  .btn-back .back-text {\n    margin-top: 6px;\n    font-size: 0.85rem;\n    color: var(--sn-texto-2);\n    font-weight: 500;\n  }\n  .payphone-card {\n    background: var(--sn-superficie);\n    border: 1px solid var(--sn-borde);\n    border-radius: 8px;\n    padding: 1rem 1.25rem;\n    max-width: 380px;          /* opcional */\n    font-size: 0.92rem;\n  }\n  \n  .payphone-title {\n    font-weight: 600;\n    font-size: 1rem;\n    letter-spacing: .4px;\n    color: var(--sn-marca);    /* acento de marca */\n  }\n\n  .payphone-card strong {\n    color: var(--sn-marca);\n  }\n  .loading-overlay {\n    position: fixed;\n    inset: 0;\n    background: var(--sn-fondo);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1050;\n    flex-direction: column;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
